<div class="row">
  <div class="col">
    <h3 class="border-bottom mt-0 text-center"><strong>{{'request-event-modal.software' | translate}}</strong></h3>
    <ul class="list-group">
      <li
        class="list-group-item d-flex justify-content-between align-items-center {{(waiterAmount > 0 ? 'bg-info text-white' : '')}}">
        <strong>Waiter</strong>
        <span class="badge badge-default badge-pill">{{waiterAmount}}</span>
      </li>
      <li
        class="list-group-item d-flex justify-content-between align-items-center {{(cashRegisterAmount > 0 ? 'bg-info text-white' : '')}}">
        <strong>Cash Register</strong>
        <span class="badge badge-default badge-pill">{{cashRegisterAmount}}</span>
      </li>
      <li
        class="list-group-item d-flex justify-content-between align-items-center {{(mainDeviceAmount > 0 ? 'bg-info text-white' : '')}}">
        <strong>Main Device</strong>
        <span class="badge badge-default badge-pill">{{mainDeviceAmount}}</span>
      </li>
      <li
        class="list-group-item d-flex justify-content-between align-items-center {{(printerAmount > 0 ? 'bg-info text-white' : '')}}">
        <strong>Printer</strong>
        <span class="badge badge-default badge-pill">{{printerAmount}}</span>
      </li>
      <li
        class="list-group-item d-flex justify-content-between align-items-center {{(fiscalPrinterAmount > 0 ? 'bg-info text-white' : '')}}">
        <strong>Fiscal Printer</strong>
        <span class="badge badge-default badge-pill">{{fiscalPrinterAmount}}</span>
      </li>
    </ul>
  </div>
  <div class="col">
    <h3 class="border-bottom mt-0 text-center"><strong>{{'request-event-modal.hardware' | translate}}</strong></h3>
    <ul class="list-group">
      <li
        class="list-group-item d-flex justify-content-between align-items-center {{(phonesAmount > 0 ? 'bg-info text-white' : '')}}">
        <strong>Phones</strong>
        <span class="badge badge-default badge-pill">{{phonesAmount}}</span>
      </li>
      <li
        class="list-group-item d-flex justify-content-between align-items-center {{(tabletAmount > 0 ? 'bg-info text-white' : '')}}">
        <strong>Tablets</strong>
        <span class="badge badge-default badge-pill">{{tabletAmount}}</span>
      </li>
      <li
        class="list-group-item d-flex justify-content-between align-items-center {{(printersAmount > 0 ? 'bg-info text-white' : '')}}">
        <strong>Printers</strong>
        <span class="badge badge-default badge-pill">{{printersAmount}}</span>
      </li>
      <li
        class="list-group-item d-flex justify-content-between align-items-center {{(fiscalPrintersAmount > 0 ? 'bg-info text-white' : '')}}">
        <strong>Fiscal Printers</strong>
        <span class="badge badge-default badge-pill">{{fiscalPrintersAmount}}</span>
      </li>
      <li
        class="list-group-item d-flex justify-content-between align-items-center {{(routersAmount > 0 ? 'bg-info text-white' : '')}}">
        <strong>Routers</strong>
        <span class="badge badge-default badge-pill">{{routersAmount}}</span>
      </li>
    </ul>
  </div>
  <div class="col">
    <h3 class="border-bottom mt-0 text-center"><strong>Accessories</strong></h3>
    <ul class="list-group">
      <li
        class="list-group-item d-flex justify-content-between align-items-center {{(cablesAmount.one > 0 ? 'bg-info text-white' : '')}}">
        <strong>1M Cable</strong>
        <span class="badge badge-default badge-pill">{{cablesAmount.one}}</span>
      </li>
      <li
        class="list-group-item d-flex justify-content-between align-items-center {{(cablesAmount.five > 0 ? 'bg-info text-white' : '')}}">
        <strong>5M Cable</strong>
        <span class="badge badge-default badge-pill">{{cablesAmount.five}}</span>
      </li>
      <li
        class="list-group-item d-flex justify-content-between align-items-center {{(cablesAmount.ten > 0 ? 'bg-info text-white' : '')}}">
        <strong>10M Cable</strong>
        <span class="badge badge-default badge-pill">{{cablesAmount.ten}}</span>
      </li>
      <li
        class="list-group-item d-flex justify-content-between align-items-center {{(cablesAmount.twenty > 0 ? 'bg-info text-white' : '')}}">
        <strong>20M Cable</strong>
        <span class="badge badge-default badge-pill">{{cablesAmount.twenty}}</span>
      </li>
      <li
        class="list-group-item d-flex justify-content-between align-items-center {{(cablesAmount.fifty > 0 ? 'bg-info text-white' : '')}}">
        <strong>50M Cable</strong>
        <span class="badge badge-default badge-pill">{{cablesAmount.fifty}}</span>
      </li>
    </ul>
  </div>
  <div class="col">
    <h3 class="border-bottom mt-0 text-center"><strong>Additional costs</strong></h3>
    <ul class="list-group">
      <ng-container *ngFor="let additionalCost of additionalCostArray">
        <li *ngIf="additionalCost.name!=='cancellation'"
          class="list-group-item d-flex justify-content-between align-items-center {{(additionalCost.quantityRequested > 0 ? 'bg-info text-white' : '')}}">
          <strong>{{'event.additionalCosts.' + additionalCost.name + '.title' | translate}}</strong>
          <span class="badge badge-default badge-pill">{{additionalCost.quantityRequested}}</span>
        </li>
      </ng-container>
    </ul>
  </div>
</div>
